import React from 'react';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import { inPercent, formatterWithWord, numberWithCommas } from 'helpers/Utils.js';
import { KeywordListContainer, ListTitle } from 'components/Pages/Reports/styled.js';
import ErrorKeywordListCard from 'components/Pages/Reports/ErrorStates/ErrorKeywordListCard.jsx';

const KeywordListCard = ({ title, resources, unit = 'num_contents' }) => {
  if (!resources || (resources && !resources.length)) {
    return <ErrorKeywordListCard title={title} unit={unit} />;
  }

  return (
    <KeywordListContainer>
      <ListTitle>{title}</ListTitle>
      {resources.map((keyword, idx) =>
        <HorizontalFillBar
          fillPct={inPercent(keyword.pct_num_contents, 1, true)}
          label={keyword.value}
          value={formatterWithWord('Content Pieces', numberWithCommas)(keyword[unit])}
          stacked
          pctWidth="100%"
          labelWidth={'30%'}
          key={`${keyword.value}-${idx}`}
        />)}
    </KeywordListContainer>
  );
};

export default KeywordListCard;
